
import { defineComponent, computed } from 'vue'
import { useStore } from '@/store/index'

export default defineComponent({
  props: {
    imageUrl: {
      type: String,
      'default': () => (''),
    },
  },
  setup() {
    const store = useStore()
    const userName = computed(() => store.state.user.user?.nick_name ? store.state.user.user.nick_name.slice(0, 2) : '匿名')
    const bgColor = computed(() => store.state.user.color ? store.state.user.color : 'bg-slate-500')

    return {
      store,
      userName,
      bgColor
    }
  },
})
